module.exports = __webpack_public_path__ + "static/img/rotate.ee5ec34.png";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/imageViewer/icon/rotate.png
// module id = mr9M
// module chunks = 100